var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-grow-warp"},[_c('span',{ref:"numberGrow",class:{ 'number-grow': _vm.isShowClass },attrs:{"data-time":_vm.time}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }